<template>
	<action-panel close="no" :icon="panelIcon" :links="panelLinks" :buttons="panelButtons" :style="colorStyle" @action="doAction">
		<div>{{ message }}</div>
		<div style="margin-top:8px"><sym-icon name="email-out"></sym-icon> {{ env.msg('sending.in') }} <seconds-timer :run="true" size="normal" :countdown="true" v-model="panel.data.seconds" :created="panel.created" @done="countdownDone"></seconds-timer></div>
	</action-panel>
</template>

<script setup lang="ts">
import {ref, computed, type CSSProperties} from "vue";
import SecondsTimer from "@/ui/action-panel/SecondsTimer.vue";
import ActionPanel from "@/ui/action-panel/ActionPanel.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {ActionPanelButton, ActionPanelLink, EventInvitationPanelInstance, type TrackerPanelInstance} from "@t/ui/ActionPanel.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import {injectEnv} from "@fd/Environment.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";

const props = defineProps<{
	panel: EventInvitationPanelInstance
}>();

const env = injectEnv();
const ns = useNavigationStore();

const panelIcon = computed<ActionPanelLink>(() => {
	return { icon: "event", srcType: SrcType.EVENT, srcId: props.panel.data.event }
});

const panelLinks = computed<ActionPanelLink[]>(() => {
	const linx:ActionPanelLink[] = [];
	if (Array.isArray(props.panel.data.links) && props.panel.data.links.length > 0) {
		linx.push(...props.panel.data.links);
	} else {
		linx.push({ title: env.msg('worksheet.event'), srcType: SrcType.EVENT, srcId: props.panel.data.event });
	}
	return linx;
});

const panelButtons = computed<ActionPanelButton[]>(() => {
	const dp:ActionPanelButton[] = [];
	dp.push({ title: env.msg('mail.dont.send'), action: "cancel" });
	dp.push({ title: env.msg('mail.send.now'), action: "send-now", bold: true });
	return dp;
});

const colorStyle = computed<CSSProperties>(() => {
	const s: CSSProperties = {};
	let hue:number;
	switch (props.panel.data.kind) {
		case "NEW":
			hue = 120;
			break;
		case "DELETE":
			hue = 0;
			break;
		default:
		case "UPDATE":
			hue = 30;
			break;
	}
	s['--button-hue'] = hue;
	s['--button-sat'] = 80;
	return s;
});

const message = computed<string>(() => {
	return env.msg('event.invitation.msg.'+props.panel.data.kind.toLowerCase());
});

function doAction(action:string, arg?:any) {
	if (action === "send-now") {
		ns.panelAction(props.panel.id, "send-now");
	} else {
		ns.panelAction(props.panel.id, "cancel");
	}
}

function countdownDone() {
	console.log("Countdown done");
}

</script>

<style>

</style>